import React from 'react';
import { Box } from '@mui/material';
import { Folder } from '../../services/folders_api';
import FolderChip from './FolderChip';

interface FolderBarProps {
  folders: Folder[];
  selectedFolderId: number | null;
  onSelect: (folderId: number | null) => void;
  dragInProgress?: boolean;
}

// ステータスタブ直下のフォルダバー。
// ピン留めフォルダのみ表示。選択中の非ピンフォルダは先頭に一時表示する。
// ピンが0個（かつ非ピン選択もなし）ならバー自体を描画しない＝行が消える。
const FolderBar: React.FC<FolderBarProps> = ({
  folders,
  selectedFolderId,
  onSelect,
  dragInProgress,
}) => {
  const pinned = folders
    .filter((f) => f.pin_order != null)
    .sort((a, b) => (a.pin_order as number) - (b.pin_order as number));

  // 選択中フォルダが非ピンなら、先頭に一時表示して「何で絞り込み中か」を可視化。
  const selected = selectedFolderId != null
    ? folders.find((f) => f.id === selectedFolderId)
    : undefined;
  const tempChip = selected && selected.pin_order == null ? selected : undefined;

  const barList = tempChip ? [tempChip, ...pinned] : pinned;
  if (barList.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        py: 0.25,
        overflowX: 'auto',
        '&::-webkit-scrollbar': { height: 0 },
        scrollbarWidth: 'none',
      }}
    >
      {barList.map((folder) => (
        <FolderChip
          key={folder.id}
          folder={folder}
          selected={selectedFolderId === folder.id}
          onClick={() => onSelect(selectedFolderId === folder.id ? null : folder.id)}
          dragInProgress={dragInProgress}
        />
      ))}
    </Box>
  );
};

export default FolderBar;
